








import { Vue, Component, Prop } from "vue-property-decorator";

@Component
export default class HasAppliedForMoreInformation extends Vue {
  @Prop({ type: String, required: true })
  readonly email!: string;

  get thankYouText() {
    return this.$t("Tack för ditt intresse {email}! Vi hör av oss inom kort!", {
      email: this.email,
    }).toString();
  }
}
